<template>
  <div>
    <b-modal
      id="default-payment-method"
      ref="default-payment-method"
      size="entry-delete"
      centered
      hide-footer
      hide-header
      @hide="close"
    >
      <div class="modal-head">
        <span class="modal-title">{{
          label.get("billing_default_payment_title")
        }}</span>
      </div>
      <div class="content-wrapper">
        <div class="field-row">
          <p>{{ label.get("billing_default_payment_description") }}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="cancel atto-btn" @click="close">
          {{ label.get("cancel") }}
        </button>
        <button
          class="atto-btn submit"
          :disabled="disabled"
          @click="deleteCard"
        >
          {{ label.get("confirm") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BillingService from "../services/BillingService";
export default {
  name: "DefaultPaymentMethodComponent",
  props: {
    card: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs["default-payment-method"].show();
  },
  methods: {
    deleteCard() {
      this.disabled = true;
      this.$store.commit("showLoading");
      BillingService.updatePaymentMethod({ paymentMethod: this.card.pid })
        .then((result) => {
          this.disabled = false;
          this.$store.commit("hideLoading");
          this.$root.$emit("hideDefaultPaymentMethod", this.card);
        })
        .catch((error) => {
          this.disabled = false;
          this.$store.commit("hideLoading");
        });
    },
    close() {
      this.$root.$emit("hideDefaultPaymentMethod");
    },
  },
};
</script>

<style lang="scss">
/* @media queries */
@mixin tabletMobile {
  @media (max-width: 768px) {
    @content;
  }
}
/* End of: @media queries */

.modal-content {
  @include tabletMobile {
    width: 95% !important;
    margin: 0 auto;
  }
}

#default-payment-method {
  .modal-footer {
    button.submit {
      @include tabletMobile {
        margin-top: 8px;
      }
    }
  }
}
</style>
